document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const container = document.querySelector('.tolstoy-carousel-videos-container');
    const arrowButtons = document.querySelectorAll('.tolstoy-carousel-arrow-button-container');

    if (container && arrowButtons.length) {
      const childCount = container.children.length;

      arrowButtons.forEach(btn => {
        btn.style.display = (childCount <= 3) ? 'none' : 'flex';
      });
    }
  }, 2500);
});

/**
 * Moves Tolstoy carousel sections to the end of #product-content
 * for products that do NOT offer subscription options.
 * 
 * This script:
 * 1. Checks if the product has subscription options (Skio plan picker)
 * 2. If no subscription is available, finds the tolstoy-carousel element
 * 3. Moves both the tolstoy-carousel's parent section and its preceding sibling
 *    to the end of #product-content
 */

function moveTolstoyForNonSubscription() {
  // Check if we're on a product page
  const productContent = document.querySelector('#product-content');
  if (!productContent) {
    return;
  }

  // Check if product has subscription options via data attribute set by Liquid
  const hasSubscription = document.body.getAttribute('data-has-subscription') === 'true';
  if (hasSubscription) {
    return;
  }

  // Product does NOT offer subscription, proceed with moving Tolstoy

  const tolstoyElement = document.querySelector('tolstoy-carousel');
  if (!tolstoyElement) {
    return;
  }

  // Go up to the parent shopify-section
  const tolstoySection = tolstoyElement.closest('.shopify-section');
  if (!tolstoySection) {
    console.warn('Tolstoy carousel found but no parent .shopify-section');
    return;
  }

  // Get the previous sibling section
  const previousSection = tolstoySection.previousElementSibling;
  if (!previousSection || !previousSection.classList.contains('shopify-section')) {
    console.warn('No valid previous sibling section found for Tolstoy carousel');
    return;
  }

  // Add custom classes for styling
  previousSection.classList.add('tolstoy-repositioned');
  tolstoySection.classList.add('tolstoy-repositioned');
  
  // Move both sections to the end of #product-content
  productContent.appendChild(previousSection);
  productContent.appendChild(tolstoySection);
}

window.addEventListener('load', function() {
  moveTolstoyForNonSubscription();
});